<script setup lang="ts">import { $socket } from "@client/lib/socket";import { useUserStore as ___useUserStore } from "@client/stores"; const $$user =  ___useUserStore();import { useGameStore as ___useGameStore } from "@client/stores"; const $$game =  ___useGameStore();import {useRouter as ___useRouter} from "vue-router";const $router = ___useRouter();
import Toaster from "@client/components/ui/toast/Toaster.vue";
import UserAvatar from "./components/ui/toast/UserAvatar.vue";
import { useToast } from "./components/ui/toast";
import { sounds } from "@client/composables/audio";
import { useColorMode } from "@vueuse/core";
const colorMode = useColorMode({
	storageKey: "color-mode",
	initialValue: "dark",
});
colorMode;
import { h } from "vue";
const { toast } = useToast();

$socket.social.off();
$socket.game.off();

$socket.social.on("receiveChat", (data) => {
	sounds.message.play();
	if (!$$user.chats[data.id]) $$user.chats[data.id] = [];
	$$user.chats[data.id].push({ content: data.content, isSelf: false });
	localStorage.setItem("chats", JSON.stringify($$user.chats));

	// Checking if message is from the active chat
	if ($$user.activeChatId !== data.id) {
		const friend = $$user.friendList.find((friend) => friend.id === data.id);
		if (!friend) return;
		$$user.setPendingChatId(data.id);
	}
});

$socket.social.on("friendStatusUpdate", (data) => {
	const friend = $$user.friendList.find((friend) => friend.id === data.id);
	if (!friend) return;
	friend.status = data.status;
});
$socket.social.on("receivedFriendRequest", (data) => {
	$$user.requests.incoming.push(data);
	toast({
		description: h(UserAvatar, { username: data.username, avatarUrl: data.avatarUrl }),
		class: "tw:!bg-neutral-800 tw:text-white tw:border-none font-rubik",
		duration: 3000,
	});
});

$socket.social.on("rejectedFriendRequest", (data) => {
	function searchAndRemoveUserById(id: number, array: any[]) {
		const index = array.findIndex((user) => user.id === id);
		if (index === -1) return;
		array.splice(index, 1);
	}
	searchAndRemoveUserById(data.id, $$user.requests.incoming);
	searchAndRemoveUserById(data.id, $$user.requests.outgoing);
});
$socket.game.on("matchFound", (data) => {
	$$game.players.opponent.info["~set"](data.opponent);
	$$game.flags.matchmaking.isMatchFound = true;
	$$game.flags.matchmaking.isFindingMatch = false;
});

$socket.game.on("opponentAccepted", (data) => {
	const { isMaster, ...selectableData } = data;
	$$game.players.user.flags.isMaster = isMaster;
	Object.assign($$game.selectableData, selectableData);
	$$game.flags.matchmaking.isSelectingUnits = true;
	$router.push({ name: "categories" });
});

$socket.game.on("opponentDeclined", () => {
	$$game["~resetEverything"]();
	$$game.players.opponent.flags.hasDeclined = true;
});

$socket.game.on("opponentLeft", () => {
	if (!$$game.flags.ingame.isGameStarted) {
		if ($router.currentRoute.value.name === "categories") $router.push({ name: "lobby" });
		return $$game["~resetEverything"]();
	}

	$$game.players.opponent.flags["~reset"]();
	$$game.players.opponent.flags.hasLeft = true;
});

$socket.game.on("opponentSentInvitation", (data) => {
	const opponent = $$user.friendList.find((friend) => friend.id === data.friendId);
	if (!opponent) return;
	sounds.find_match.play();
	$$game.players.opponent.info["~set"]({
		id: opponent.id,
		username: opponent.username,
		medPoints: opponent.medPoints ?? 0,
		avatarUrl: opponent.avatarUrl,
		university: opponent.university,
	});
	$$game.players.user.flags.isInvited = true;
});

$socket.game.on("gameStarted", (data) => {
	$$game.data.cases = data.cases;
	$$game.flags.ingame.isGameStarted = true;
	$$game.gameId = data.gameId;
	$router.push({ name: "exam" });
});

$socket.game.on("connect_error", (error) => {
	console.error(error);
	$$game.fatalErrorMessage = error.message;
});
$socket.game.on("error", (error) => {
	console.error(error);
	$$game.fatalErrorMessage = error.message;
});
</script>
<template>
	<suspense>
		<v-app>
			<component :is="$route?.meta?.layoutComponent">
				<Toaster />

				<router-view />
			</component>
		</v-app>
	</suspense>
</template>
